export default "__VITE_ASSET__BT1$1UoJ__"